import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'

import Page from '../../components/layout/Page'
import Container from '../../components/layout/Container'
import FullSizeSection from '../../components/layout/FullSizeSection'
import ContactForm from '../../components/layout/ContactForm'
import { ApplicationState, ConnectedReduxProps } from '../../store'
import { Contact } from '../../store/contacts/types'
import { fetchRequest } from '../../store/contact/actions'
import styled, { Theme } from '../../utils/styled'
import StringHelper from '../../utils/StringHelper'
import Loadingbar from '../../components/layout/Loaderbar'
import { darken } from 'polished'
import { Themed } from 'react-emotion'
import { Dispatch } from 'redux'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'

library.add(faArrowRight, faArrowLeft)
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
  loading: boolean
  data: Contact[]
  selected: Contact
  errors?: string
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
}

interface RouteParams {
  name: string
}

interface State {
  selected?: Contact
  data: Contact[]
}
// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState &
  PropsFromDispatch &
  RouteComponentProps<RouteParams> &
  ConnectedReduxProps

class ShowContactsPage extends React.Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props)
    this.state = {
      selected: undefined
    }
  }
  private goto(event: any) {
    const route = $(event.currentTarget).attr('to')
    this.props.history.push(route)
  }
  public componentDidMount() {
    const { selected, match } = this.props
    if (!selected || selected.length === 0) {
      this.props.fetchRequest()
    }
  }
  public createMarkup(str: string) {
    return {
      __html: str
    }
  }

  public render() {
    const { data, selected, loading, match } = this.props
    return (
      <Page>
        <Container>
          <Wrapper>
            {loading && <Loadingbar />}

            {selected != undefined && (
              <div>
                <FullSizeSection
                  title={selected.name.toUpperCase()}
                  subtitle={selected.towncity}
                  backgroundImage={
                    selected.hasOwnProperty('cover') ? selected.cover.url : undefined
                  }
                  className="project"
                >
                  <Left>
                    <ContactForm />
                  </Left>
                </FullSizeSection>
              </div>
            )}
          </Wrapper>
        </Container>
      </Page>
    )
  }
}
const html = function(body: string) {
  let regex = /userdata/gi
  body = body.replace(regex, 'http://localhost/userdata')
  console.log(body)
  let result = [body]
  return result
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = ({ contact }: ApplicationState) => ({
  loading: contact.loading,
  errors: contact.errors,
  data: contact.data,
  selected: contact.selected
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRequest: () => dispatch(fetchRequest())
})

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowContactsPage)

const Wrapper = styled('div')`
  position: relative;
`

const Left = styled('div')`
  // position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`
